
import clsx from 'clsx'
import React, { ReactElement, useState } from 'react'
import { CreateAppModal, Dropdown1 } from '../../../../partials'
import { useLayout } from '../../../core'
import { KTIcon } from '../../../../helpers/components/KTIcon'
import { RootState } from '../../../../../redux/store'
import { useSelector } from 'react-redux'

interface Props {
    filters: ReactElement | undefined
}

const ToolbarClassic = ({ filters }: Props) => {
    const auth = useSelector((state: RootState) => state.auth)
    const { config } = useLayout()
    const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
    const daterangepickerButtonClass = config.app?.toolbar?.fixed?.desktop
        ? 'btn-light'
        : 'bg-body btn-color-gray-700 btn-active-color-primary'

    return (
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
            {
                filters && (
                    <React.Fragment>
                        {filters}
                    </React.Fragment>
                )
            }

            {config.app?.toolbar?.daterangepickerButton && (
                <div
                    data-kt-daterangepicker='true'
                    data-kt-daterangepicker-opens='left'
                    className={clsx(
                        'btn btn-sm fw-bold  d-flex align-items-center px-4',
                        daterangepickerButtonClass
                    )}
                >
                    <div className='text-gray-600 fw-bold'>Loading date range...</div>
                    <KTIcon iconName='calendar-8' className='fs-1 ms-2 me-0' />
                </div>
            )}

            {config.app?.toolbar?.secondaryButton && (
                <a href='#' className='btn btn-sm btn-flex btn-light fw-bold'>
                    Filter
                </a>
            )}

            {/* {config.app?.toolbar?.primaryButton && (
        
      )} */}
            <CreateAppModal show={showCreateAppModal} handleClose={() => setShowCreateAppModal(false)} />
        </div>
    )
}

export { ToolbarClassic }
